const setStore = (data) => {
    const olddata = JSON.parse(localStorage.getItem('data'))
    return localStorage.setItem('data', JSON.stringify({...olddata, ...data}))
}

const removeStore = () => {
    return localStorage.removeItem('data')
}

const getStore = () => {
    return localStorage.getItem('data')
}


export { getStore as store, setStore, removeStore }